// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xBreakpointMediaQueries from "@bg/XDL/Utilities/breakpointMediaQueries";
import breakpointMediaQueries, {
    mediaOptions as mediaOptionsType,
} from "@insite/mobius/utilities/breakpointMediaQueries";

/**
 * 
 * @param action [lt|lte|gt|gte|number]
 * @param size [xs|sm|md|lg|xl|number]
 * @returns 
 * 
 * @example
 * 
    ${xScreen("lt", "md")} {
        background-color: ${getColor("common.ui1")};
        font-size: ${Math.max(100 + 200)}px;
    }
    
    xScreen("lte", 1000)
 xScreen(500, 1000)
 */
const xScreen = (action: string | number, size: string | number) => {
    const points = ["xs", "sm", "md", "lg", "xl"];
    const media: any[] = [null, null, null, null, null];
    let mediaOptions: keyof typeof mediaOptionsType;
    let isEqual = false;

    if (["lt", "lte"].indexOf(action as string) !== -1) {
        mediaOptions = "max";
    } else if (["gt", "gte"].indexOf(action as string) !== -1) {
        mediaOptions = "min";
    } else {
        mediaOptions = "minMax";
    }

    if (["lte", "gte"].indexOf(action as string) !== -1) {
        isEqual = true;
    }

    return (props: any) => {
        let query;
        const idx = points.indexOf(size as string);
        if (idx !== -1) {
            // if (!isEqual && mediaOptions === "max" && idx !== 0) {
            //     idx--;
            // }
            // if (!isEqual && mediaOptions === "min" && idx !== 4) {
            //     idx++;
            // }
            media[idx] = "-";
            const regex = /\{(.|\n)*\}/gim;
            query = xBreakpointMediaQueries(props.theme, media, mediaOptions, isEqual);
            query = query.replace(regex, "");
        } else if (mediaOptions === "min" || mediaOptions === "max") {
            query = `@media (${mediaOptions}-width: ${+size - (!isEqual ? 1 : 0)}px)`;
        } else {
            query = `@media (min-width: ${action}px) and (max-width: ${size}px)`;
        }

        return query;
    };
};

export default xScreen;
